import { useEffect } from 'react'
import teads from 'lib/teads'

function useTeads(pageId) {
  useEffect(() => {
    teads.loadScript()
    ;(function (d, p) {
      var js,
        s = d.getElementsByTagName('script')[0]
      js = d.createElement('script')
      js.className = 'teads'
      js.async = true
      js.type = 'text/javascript'
      js.src = '//a.teads.tv/page/' + p + '/tag'
      s.parentNode.insertBefore(js, s)
    })(window.document, pageId)
    return () => {
      try {
        window.teads.cleanup()
      } catch (e) {}
    }
  }, [pageId])
}

export default useTeads
